import { isBrowser } from "../environmentDetection/library";
import { getString } from "config-api";
import newsletters from "./constants";

/**
 *
 * @returns the appropriate newsletters url depending on the environment
 */
export const identifyNewsletterSourceAPI = () => {
    if (!isBrowser()) {
        return getString("Client.newsletters.ApiUrl");
    }
    const ocelotNewsletterEnvironment =
        new URLSearchParams(document.location.search).get(
            "forceNewsletterEnv"
        ) || null;

    return ocelotNewsletterEnvironment
        ? newsletters.api.url[ocelotNewsletterEnvironment]
        : getString("Client.newsletters.ApiUrl");
};
